declare namespace $ {

	type $shm_hitalama_map_page_contextmenu__Map_page_shm_hitalama_map_widget_presets_page_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_presets_page['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['Map_page'] >
	>
	type $shm_hitalama_map_page_contextmenu__add_pos_shm_hitalama_map_widget_presets_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_presets_page['add_pos'] >
		,
		ReturnType< $shm_hitalama_map_page_contextmenu['add_pos'] >
	>
	export class $shm_hitalama_map_widget_presets_page extends $mol_page {
		Map_page( ): $shm_hitalama_map_page
		add_pos( ): readonly(any)[]
		Add_widget_menu( ): $shm_hitalama_map_page_contextmenu
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map